import gql from 'graphql-tag';

export const doClockInMutation = gql`
  mutation doClockIn($activityId: Int, $date: Date, $userId: Int) {
    doClockIn(activityId: $activityId, date: $date, userId: $userId) {
      id
      clockedInAt
      status
    }
  }
`;

export const cancelClockInMutation = gql`
  mutation cancelClockIn($id: Int) {
    cancelClockIn(id: $id) {
      id
      clockedInAt
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/clockIn.ts